import { ChevronDown, ReceiptText } from 'lucide-react'
import type { JournalTrade } from '../types'

export function JournalCharges({ trade }: { trade: JournalTrade }) {
  const charges = trade.chargeBreakdown
  return (
    <section className="jn-panel" aria-label="Charges breakdown">
      <details className="jn-charge-details">
        <summary className="jn-panel-heading">
          <div className="flex items-center gap-2"><ReceiptText size={14} className="text-muted-foreground" /><h3>Charges</h3></div>
          <div className="flex items-center gap-2">
            <strong className="num">₹{trade.chargesPaid.toFixed(2)}</strong>
            <span className="jn-badge">{trade.chargesSource === 'BROKER' ? 'Broker' : 'Estimated'}</span>
            <ChevronDown size={12} className="jn-charge-chevron" />
          </div>
        </summary>
        {charges === null ? <span className="jn-empty-value">Not recorded</span> : (
          <div className="jn-charge-lines">
            {trade.chargesSource === 'BROKER' && <div className="jn-caption mb-2">Estimated split <span className="num">₹{charges.total.toFixed(2)}</span></div>}
            <dl>{([
              ['STT', charges.stt], ['EXCH', charges.exchangeTurnover], ['STAMP', charges.stampDuty],
              ['GST', charges.gst], ['SEBI', charges.sebiTurnover], ['BRK', charges.brokerage],
            ] as const).map(([label, value]) => <div key={label}><dt>{label}</dt><dd className="num">₹{value.toFixed(2)}</dd></div>)}</dl>
          </div>
        )}
      </details>
    </section>
  )
}
